import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css'],
})
export class AboutComponent implements OnInit {
  title = 'about me';
  name = {
    first: 'Vikas',
    last: 'Gupta',
  };
  image = {
    background: '../../assets/images/about.jpg',
    profile: '../../assets/images/profile.png',
  };
  contactDetails = [
    {
      icon: 'fa fa-envelope',
      text: 'cse.vikashgupta@gmail.com',
      link: 'mailto:cse.vikashgupta@gmail.com?Subject=Profile%20Visitor',
    },
    {
      icon: 'fa fa-mobile-alt',
      text: '+91 7733930399',
      link: 'tel:+917733930399',
    },
    {
      icon: 'fab fa-linkedin-in',
      text: 'LinkedIn',
      link: 'https://www.linkedin.com/in/vkasgupta/',
    },
    {
      icon: 'fab fa-stack-overflow',
      text: 'Github',
      link: 'https://github.com/dev-vikasgupta',
    },
    {
      icon: 'fab fa-github',
      text: 'Stackoverflow',
      link: 'https://stackoverflow.com/users/8498296/cse-vikashgupta',
    },
  ];
  yearOfExperience = '6';
  position = 'Frontend Engineer ||';
  company = 'Amazon';
  location = ' Hyderabad, telangana';
  descriptions = [
    `I have ${this.yearOfExperience}+ years of experience in full stack web development in javascript frameworks.
    Currently, I am a ${this.position} at ${this.company}, located in ${this.location}.
    `,
  ];
  responsibilities = [
    'At Amazon Pay, I am part of the amazon pay gateway team, gateway to 40+ bill payments categories',
    'Here, I work on creating reusable components and help internal amazon pay clients to build new features that fit with the existing CX',
    'I also helped building a design system to keep the CX consistent.',
    'Help follow best practices in development workflow',
    'Accessibility is never a choice'
  ];
  constructor() {}

  ngOnInit(): void {}
}
